import { useRef, useEffect, useState } from "react";
import useImagesLoaded from "../../hooks/useImagesLoaded";

import AgriSimHero from "../../components/AgriSim/AgriSimHero";
import AgroFlyteAbout from "../../components/AgriSim/AgroFlyte";
import Technology from "../../components/AgriSim/Technology";
import Vision from "../../components/AgriSim/Vision";
import AgriCapabilities from "../../components/AgriSim/AgriCapabilities";
import AgriSimContact from "../../components/AgriSim/AgriSimContact";
import SupportTicketPopup from "../../components/AgriSim/SupportTicketPopup";

// Resolve the API base URL for ticket operations.
// Set REACT_APP_TICKET_SERVICE_URL in the frontend .env for local dev (e.g. http://localhost:5000).
const TICKET_API =
    process.env.REACT_APP_TICKET_SERVICE_URL || process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";


export default function AgriSimPage() {
    const containerRef = useRef(null);
    useImagesLoaded(containerRef);

    // popup state: null = hidden, { token, streamId } = visible
    const [ticketPopup, setTicketPopup] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const support = params.get("support");
        const token = params.get("token");

        // Only proceed if both params are present and correct.
        // Missing or mismatched values = silently do nothing — normal visitors
        // never see the popup even if they guess the ?support=open param.
        if (support !== "open" || !token) return;

        let cancelled = false;

        fetch(`${TICKET_API}/api/support-token/validate?token=${encodeURIComponent(token)}`)
            .then((res) => (res.ok ? res.json() : { valid: false }))
            .then((data) => {
                if (cancelled) return;
                if (data.valid) {
                    // Token is valid — show the popup with the server-resolved streamId
                    setTicketPopup({ token, streamId: data.streamId });
                }
                // valid: false — do nothing. Page behaves exactly as normal.
            })
            .catch(() => {
                // Network error — treat as invalid, show nothing.
            });

        return () => { cancelled = true; };
    }, []);

    return (
        <main ref={containerRef}>
            <AgriSimHero />
            <AgroFlyteAbout />
            <Vision />
            <Technology />
            <AgriCapabilities />
            <AgriSimContact />

            {/* Support ticket popup — only rendered when arrived from in-game Help */}
            {ticketPopup && (
                <SupportTicketPopup
                    token={ticketPopup.token}
                    streamId={ticketPopup.streamId}
                    onClose={() => setTicketPopup(null)}
                />
            )}
        </main>
    );
}
